"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationBasicProfile',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        activate: '启用',
        deactivate: '停用',
        blacklist: '拉黑'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationBasicProfileListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('客户姓名', '新增基础资料').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationBasicProfileSaveApi)({
          name: value || 'E2E客户',
          mobile: "138".concat(String(Date.now()).slice(-8)),
          intentionLevel: 'B',
          remark: '后台新增',
          sourceType: 'manual',
          stage: 'prospect'
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      (0, _decoration.decorationBasicProfileActionApi)(row.customer.id, {
        action: action
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    }
  }
};